/**
 * Sorts students by monthly performance (highest first, zeros at bottom)
 */
export function sortStudentsByMonthlyPerformance(
  students: any[],
  monthlyPerformanceMap: Map<string, number>
) {
  if (!students || students.length === 0) {
    return [];
  }

  const sorted = [...students].sort((a, b) => {
    const perfA = monthlyPerformanceMap.get(a.id) ?? 0;
    const perfB = monthlyPerformanceMap.get(b.id) ?? 0;

    if (perfA === 0 && perfB === 0) return 0;
    if (perfA === 0) return 1;
    if (perfB === 0) return -1;

    return perfB - perfA;
  });

  return sorted;
}

/**
 * Transforms student data for StudentsTable with monthly performance as averageScore
 */
export function prepareStudentsForTable(
  students: any[],
  monthlyPerformanceMap: Map<string, number>
) {

  return students.map(student => ({
    id: student.id,
    name: student.name,
    statistic: {
      averageScore: monthlyPerformanceMap.get(student.id) ?? 0,
    }
  }));
}

/**
 * Transforms studentsMonthlyReports array into format required for StudentsTable
 * @param studentsMonthlyReports - Array of student monthly report objects from classMonthlyReport
 * @returns Array of objects with {id, name, statistic: {averageScore}}
 */
export function transformStudentsMonthlyReportsForTable(
  studentsMonthlyReports: any[],
  studentsById: Map<string, any> = new Map()
): Array<{
  id: any;
  name: any;
  statistic: {
    averageScore: number;
  };
}> {
  if (!studentsMonthlyReports || studentsMonthlyReports.length === 0) {
    return [];
  }

  return studentsMonthlyReports
    .map(report => {
      const studentId = report.studentId || report.student?.id || report.student?._id;
      const rosterStudent = studentsById.get(studentId);

      return {
        id: studentId,
        name: rosterStudent?.name || report.student?.name || 'Unknown Student',
        statistic: {
          averageScore: Number.isFinite(report.studentMonthlyAverage)
            ? Number(report.studentMonthlyAverage.toFixed(1))
            : 0,
        }
      };
    })
    .sort((a, b) => {
      // Sort by averageScore descending, zeros at bottom
      if (a.statistic.averageScore === 0 && b.statistic.averageScore === 0) return 0;
      if (a.statistic.averageScore === 0) return 1;
      if (b.statistic.averageScore === 0) return -1;
      return b.statistic.averageScore - a.statistic.averageScore;
    });
}
